/* luna.bundle.js: luna, luna-cart, luna-extra, luna-v10, luna-v31, luna-v32 concatenated in their original order (v39). Each file is isolated so an error in one cannot stop the others, just like separate <script> tags. Edit the source files, then rebuild this bundle. */
/* ==== luna.js ==== */
try {
// ===== Verified Amazon preorder links =====
const LINKS = {
  ebook: 'https://www.amazon.com/dp/B0HN1FYY5R',
  paperback: ''   // e.g. 'https://www.amazon.com/dp/XXXXXXXXXX'
};
const SEARCH = 'https://www.amazon.com/s?k=Red+Moon+Aaron+Holden';
document.querySelectorAll('[data-buy]').forEach(a => {
  const live = LINKS[a.dataset.buy];
  if (live) {
    a.href = live; a.target = '_blank'; a.rel = 'noopener';
    a.classList.remove('is-soon');
    a.title = 'Pre-order Red Moon by Aaron Holden on Amazon Kindle';
    a.querySelectorAll('.soon').forEach(label => label.remove());
    const sub = a.querySelector('.fmt-sub');
    if (sub) sub.textContent = 'Amazon · pre-order';
    if (a.dataset.buy === 'ebook') {
      [...a.childNodes].filter(node => node.nodeType === Node.TEXT_NODE).forEach(node => {
        node.textContent = node.textContent.replace('Coming to Kindle', 'Pre-order Kindle eBook');
      });
    }
    return;
  }
  // Not on Amazon yet: point readers to the contact section instead of an empty search.
  a.href = document.getElementById('contact') ? '#contact' : '/#contact'; a.removeAttribute('target'); a.removeAttribute('rel');
  a.classList.add('is-soon'); a.title = 'Coming to Amazon soon. Email Aaron for updates.';
  const sub = a.querySelector('.fmt-sub');
  if (sub) sub.textContent = 'Amazon · coming soon';
  else if (!a.querySelector('.soon')) { const s = document.createElement('span'); s.className = 'soon'; s.textContent = 'Coming soon'; a.appendChild(s); }
});

const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
const finePointer = matchMedia('(pointer: fine)').matches;

// ===== Theme =====
(() => {
  const root = document.documentElement;
  const btn = document.querySelector('[data-theme-toggle]');
  let theme = root.getAttribute('data-theme') || 'dark';
  const sun = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><circle cx="12" cy="12" r="4.5"/><path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"/></svg>';
  const moon = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z"/></svg>';
  const apply = () => {
    root.setAttribute('data-theme', theme);
    btn.innerHTML = theme === 'dark' ? sun : moon;
    btn.setAttribute('aria-label', 'Switch to ' + (theme === 'dark' ? 'light' : 'dark') + ' mode');
  };
  apply();
  btn.addEventListener('click', () => { theme = theme === 'dark' ? 'light' : 'dark'; apply(); });
})();

// ===== Split hero title into animated letters =====
document.querySelectorAll('[data-split]').forEach(el => {
  const text = el.textContent.trim();
  el.setAttribute('aria-label', text);
  el.innerHTML = text.split(' ').map((word, wi, arr) => {
    const chars = [...word].map((ch, ci) => {
      const idx = arr.slice(0, wi).join('').length + ci;
      return `<span class="split-char" style="animation-delay:${(0.25 + idx * 0.045).toFixed(3)}s">${ch}</span>`;
    }).join('');
    return `<span class="split-line" aria-hidden="true">${chars}</span>`;
  }).join(' ');
});

// ===== Header: scrolled / hide-on-scroll + progress bar =====
(() => {
  const h = document.querySelector('.site-header');
  const bar = document.querySelector('.progress span');
  let last = 0, ticking = false;
  const update = () => {
    const y = scrollY;
    const max = document.documentElement.scrollHeight - innerHeight;
    if (bar) bar.style.transform = `scaleX(${max > 0 ? y / max : 0})`;
    h.classList.toggle('scrolled', y > 20);
    last = y; ticking = false;
  };
  addEventListener('scroll', () => { if (!ticking) { requestAnimationFrame(update); ticking = true; } }, { passive: true });
  update();
})();

// ===== Mobile menu =====
(() => {
  const btn = document.querySelector('.menu-btn');
  const menu = document.getElementById('menu');
  if (!btn || !menu) return;
  const set = open => {
    menu.hidden = !open;
    btn.setAttribute('aria-expanded', open);
    btn.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    btn.textContent = open ? 'Close' : 'Menu';
    document.body.classList.toggle('menu-open', open);
  };
  btn.addEventListener('click', () => set(menu.hidden));
  menu.querySelectorAll('a').forEach(a => a.addEventListener('click', () => set(false)));
  addEventListener('keydown', e => { if (e.key === 'Escape' && !menu.hidden) set(false); });
})();

// ===== Nav scrollspy with sliding underline =====
(() => {
  const nav = document.querySelector('.nav');
  const ink = nav && nav.querySelector('.nav-ink');
  const links = [...document.querySelectorAll('.nav [data-spy]')];
  const moveInk = a => {
    if (!ink) return;
    if (!a) { ink.style.opacity = 0; return; }
    // Measure from the link's position inside the nav (not the viewport), so the
    // underline stays put even while the swipeable nav row is scrolling.
    ink.style.width = a.offsetWidth + 'px';
    ink.style.transform = `translateX(${a.offsetLeft}px)`;
    ink.style.opacity = 1;
  };
  const current = document.querySelector('.nav [aria-current]');
  const settle = () => moveInk(document.querySelector('.nav [aria-current]'));
  if (current) { moveInk(current); document.fonts && document.fonts.ready.then(settle); addEventListener('load', settle); }
  const sections = links.map(a => document.getElementById(a.dataset.spy)).filter(Boolean);
  if (!sections.length) return;
  const io = new IntersectionObserver(entries => {
    entries.forEach(en => {
      if (!en.isIntersecting) return;
      links.forEach(a => a.removeAttribute('aria-current'));
      const a = links.find(l => l.dataset.spy === en.target.id);
      if (a) { a.setAttribute('aria-current', 'true'); moveInk(a); }
    });
  }, { rootMargin: '-45% 0px -50% 0px' });
  sections.forEach(s => io.observe(s));
  const hero = document.querySelector('.hero');
  if (hero) new IntersectionObserver(([en]) => { if (en.isIntersecting) { links.forEach(a => a.removeAttribute('aria-current')); moveInk(null); } }, { rootMargin: '-45% 0px -50% 0px' }).observe(hero);
  addEventListener('resize', () => moveInk(document.querySelector('.nav [aria-current]')));
})();

// ===== Split section headings into rising words =====
document.querySelectorAll('[data-reveal] .h2, .section-head .h2').forEach(h => {
  if (h.dataset.words) return; h.dataset.words = 1;
  let i = 0;
  const walk = node => {
    [...node.childNodes].forEach(n => {
      if (n.nodeType === 3) {
        const frag = document.createDocumentFragment();
        n.textContent.split(/(\s+)/).forEach(part => {
          if (!part) return;
          if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
          const o = document.createElement('span'); o.className = 'word';
          const inner = document.createElement('span'); inner.style.setProperty('--wi', i++); inner.textContent = part;
          o.appendChild(inner); frag.appendChild(o);
        });
        n.replaceWith(frag);
      } else if (n.nodeType === 1) walk(n);
    });
  };
  walk(h);
});

// ===== Reveal + clip-reveal, with stagger =====
(() => {
  const els = document.querySelectorAll('[data-reveal],[data-clip]');
  if (!('IntersectionObserver' in window) || reduce) { els.forEach(e => e.classList.add('in')); return; }
  document.documentElement.classList.add('motion-ready');
  document.querySelectorAll('.dir-entries, .scenes-grid').forEach(g => {
    [...g.children].forEach((c, i) => c.style.setProperty('--rd', (i * 0.09) + 's'));
  });
  const io = new IntersectionObserver(entries => {
    entries.forEach(en => { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
  els.forEach(e => io.observe(e));
})();

// ===== Count-up stats =====
(() => {
  const nums = document.querySelectorAll('[data-count]');
  if (!nums.length || reduce) return;
  const io = new IntersectionObserver(entries => {
    entries.forEach(en => {
      if (!en.isIntersecting) return;
      const el = en.target, end = +el.dataset.count, t0 = performance.now(), dur = 1400;
      const step = t => {
        const p = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - p, 3);
        el.textContent = (el.dataset.prefix || '') + Math.round(end * e);
        if (p < 1) requestAnimationFrame(step);
      };
      el.textContent = (el.dataset.prefix || '') + '0'; requestAnimationFrame(step); io.unobserve(el);
    });
  }, { threshold: 0.6 });
  nums.forEach(n => io.observe(n));
})();

// ===== Parallax for bands =====
(() => {
  if (reduce) return;
  const items = [...document.querySelectorAll('[data-parallax]')].map(s => ({ s, img: s.querySelector('img') })).filter(x => x.img);
  if (!items.length) return;
  let ticking = false;
  const update = () => {
    items.forEach(({ s, img }) => {
      const r = s.getBoundingClientRect();
      if (r.bottom < 0 || r.top > innerHeight) return;
      const p = (r.top + r.height / 2 - innerHeight / 2) / (innerHeight + r.height);
      img.style.transform = `translate3d(0, ${(p * -14).toFixed(2)}%, 0)`;
    });
    ticking = false;
  };
  addEventListener('scroll', () => { if (!ticking) { requestAnimationFrame(update); ticking = true; } }, { passive: true });
  update();
})();

// ===== 3D tilt on cover / portrait =====
(() => {
  if (reduce || !finePointer) return;
  document.querySelectorAll('[data-tilt]').forEach(el => {
    el.addEventListener('pointermove', e => {
      const r = el.getBoundingClientRect();
      const x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
      el.style.transform = `rotateY(${x * 12}deg) rotateX(${-y * 10}deg) scale(1.02)`;
      el.style.setProperty('--gx', (x + 0.5) * 100 + '%');
      el.style.setProperty('--gy', (y + 0.5) * 100 + '%');
    });
    el.addEventListener('pointerleave', () => { el.style.transform = ''; });
  });
})();

// ===== Black Rain: layered, wind-blown, with splashes, cursor deflection and lightning =====
(() => {
  const canvases = [...document.querySelectorAll('canvas.rain')];
  if (!canvases.length) return;
  const rootEl = document.documentElement;
  const rgb = () => getComputedStyle(rootEl).getPropertyValue('--rain').trim() || '210,190,185';
  let color = rgb();
  const PRESET = { hero: { dens: 2600, max: 520, splash: true, bolt: true }, band: { dens: 3200, max: 360, splash: false, bolt: false }, soft: { dens: 5200, max: 220, splash: true, bolt: false } };
  const engines = canvases.map(c => {
    const opt = PRESET[c.dataset.rain] || PRESET.band;
    const ctx = c.getContext('2d');
    const host = c.parentElement;
    const dpr = Math.min(devicePixelRatio || 1, 2);
    let w = 0, h = 0, drops = [], splashes = [], bolt = null, visible = false;
    let mx = -9999, my = -9999;
    const mk = (init) => {
      const z = Math.pow(Math.random(), 1.6) * 0.85 + 0.15;           // depth: far (0.15) → near (1)
      return { x: Math.random() * (w + 200) - 100, y: init ? Math.random() * h : -Math.random() * h * 0.5 - 20,
               z, l: 8 + z * 34, v: 5 + z * 13, a: 0.06 + z * 0.34, lw: 0.5 + z * 1.1, dx: 0 };
    };
    const resize = () => {
      w = c.clientWidth; h = c.clientHeight; if (!w || !h) return;
      c.width = w * dpr; c.height = h * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      const n = Math.round(Math.min(opt.max, (w * h) / opt.dens) * (w < 600 ? 0.7 : 1));
      drops = Array.from({ length: n }, () => mk(true));
    };
    if (finePointer) {
      host.addEventListener('pointermove', e => { const r = c.getBoundingClientRect(); mx = e.clientX - r.left; my = e.clientY - r.top; });
      host.addEventListener('pointerleave', () => { mx = my = -9999; });
    }
    const makeBolt = () => {
      let x = w * (0.25 + Math.random() * 0.6), y = 0; const pts = [[x, y]];
      const end = h * (0.35 + Math.random() * 0.3);
      while (y < end) { y += 14 + Math.random() * 26; x += (Math.random() - 0.5) * 46; pts.push([x, y]); }
      return { pts, life: 1 };
    };
    const draw = (wind) => {
      ctx.clearRect(0, 0, w, h);
      ctx.lineCap = 'round';
      for (const d of drops) {
        const vx = (wind + d.dx) * (0.6 + d.z);
        ctx.strokeStyle = `rgba(${color},${d.a})`;
        ctx.lineWidth = d.lw;
        ctx.beginPath(); ctx.moveTo(d.x - vx * d.l / d.v, d.y - d.l); ctx.lineTo(d.x, d.y); ctx.stroke();
      }
      for (const s of splashes) {
        ctx.fillStyle = `rgba(${color},${s.a * s.life})`;
        ctx.beginPath(); ctx.arc(s.x, s.y, s.r, 0, Math.PI * 2); ctx.fill();
      }
      if (bolt) {
        ctx.strokeStyle = `rgba(255,236,228,${0.55 * bolt.life})`;
        ctx.lineWidth = 1.6; ctx.shadowColor = 'rgba(255,200,190,.8)'; ctx.shadowBlur = 18 * bolt.life;
        ctx.beginPath(); bolt.pts.forEach(([x, y], i) => i ? ctx.lineTo(x, y) : ctx.moveTo(x, y)); ctx.stroke();
        ctx.shadowBlur = 0;
      }
    };
    return { c, host, opt, resize, draw, get visible() { return visible; }, set visible(v) { visible = v; },
      step(t, wind) {
        for (const d of drops) {
          if (mx > -999) {                                   // cursor pushes rain aside
            const ddx = d.x - mx, ddy = d.y - my, dist = Math.hypot(ddx, ddy);
            if (dist < 110) d.dx += (ddx > 0 ? 1 : -1) * (1 - dist / 110) * 1.4 * d.z;
          }
          d.dx *= 0.92;
          d.y += d.v; d.x += (wind + d.dx) * (0.6 + d.z);
          if (d.y - d.l > h) {
            if (opt.splash && d.z > 0.6 && splashes.length < 160) {
              for (let k = 0; k < 2 + (Math.random() * 2 | 0); k++)
                splashes.push({ x: d.x, y: h - 2, vx: (Math.random() - 0.5) * 2.4, vy: -1.2 - Math.random() * 2.2, r: 0.6 + Math.random() * 0.9, a: 0.5 * d.z, life: 1 });
            }
            Object.assign(d, mk(false));
          }
          if (d.x < -120) d.x = w + 100; else if (d.x > w + 120) d.x = -100;
        }
        for (let i = splashes.length - 1; i >= 0; i--) {
          const s = splashes[i]; s.x += s.vx; s.y += s.vy; s.vy += 0.18; s.life -= 0.04;
          if (s.life <= 0) splashes.splice(i, 1);
        }
        if (opt.bolt) {
          if (!bolt && Math.random() < 0.0016) {
            bolt = makeBolt();
            host.style.setProperty('--fx', (bolt.pts[0][0] / w * 100).toFixed(0) + '%');
            host.classList.remove('flash'); void host.offsetWidth; host.classList.add('flash'); dispatchEvent(new CustomEvent('rm:bolt'));
          }
          if (bolt) { bolt.life -= 0.035; if (bolt.life <= 0) bolt = null; }
        }
        draw(wind);
      }, drawStatic() { draw(-1); } };
  });
  new MutationObserver(() => { color = rgb(); if (reduce) engines.forEach(e => e.drawStatic()); }).observe(rootEl, { attributes: true, attributeFilter: ['data-theme'] });
  engines.forEach(e => e.resize());
  addEventListener('resize', () => engines.forEach(e => e.resize()));
  if (reduce) { engines.forEach(e => e.drawStatic()); return; }
  let gust = 0, gustT = 0, raf = 0;
  const anyVisible = () => engines.some(e => e.visible);
  const kick = () => { if (!raf && !document.hidden && anyVisible()) raf = requestAnimationFrame(loop); };
  const io = new IntersectionObserver(entries => { entries.forEach(en => { const e = engines.find(x => x.c === en.target); if (e) e.visible = en.isIntersecting; }); kick(); });
  engines.forEach(e => io.observe(e.c));
  document.addEventListener('visibilitychange', kick);
  const loop = t => {
    if (document.hidden || !anyVisible()) { raf = 0; return; }
    {
      if (t > gustT) { gust = (Math.random() - 0.3) * 3; gustT = t + 3000 + Math.random() * 5000; }
      const wind = -1.2 + Math.sin(t / 2600) * 0.8 + gust * 0.5;
      engines.forEach(e => { if (e.visible) e.step(t, wind); });
    }
    raf = requestAnimationFrame(loop);
  };
  kick();
})();

// ===== Cursor spotlight in heroes =====
(() => {
  if (!finePointer || reduce) return;
  document.querySelectorAll('.hero, .author-hero').forEach(sec => {
    sec.addEventListener('pointermove', e => {
      const r = sec.getBoundingClientRect();
      sec.style.setProperty('--mx', (e.clientX - r.left) + 'px');
      sec.style.setProperty('--my', (e.clientY - r.top) + 'px');
    });
  });
})();

// ===== Hero scroll-out: cover drifts (copy stays fully visible) =====
(() => {
  if (reduce) return;
  const hero = document.querySelector('.hero, .author-hero');
  if (!hero) return;
  const cover = hero.querySelector('.hero-cover, .author-portrait');
  const copy = hero.querySelector('.hero-copy, .author-hero-copy');
  let ticking = false, last = -1;
  const upd = () => {
    const r = hero.getBoundingClientRect();
    const p = Math.min(1, Math.max(0, -r.top / (r.height * 0.9)));
    if (p === last) { ticking = false; return; } last = p;
    if (cover) { cover.style.translate = `0 ${(p * 90).toFixed(1)}px`; cover.style.scale = (1 - p * 0.08).toFixed(3); }
    // v41: copy no longer fades on scroll (it left the price cards and links at ~20% opacity).
    ticking = false;
  };
  addEventListener('scroll', () => { if (!ticking) { requestAnimationFrame(upd); ticking = true; } }, { passive: true });
})();

// ===== Magnetic buttons =====
(() => {
  if (!finePointer || reduce) return;
  document.querySelectorAll('.btn, .pub-badge').forEach(b => {
    b.addEventListener('pointermove', e => {
      const r = b.getBoundingClientRect();
      const x = e.clientX - r.left - r.width / 2, y = e.clientY - r.top - r.height / 2;
      b.style.translate = `${(x * 0.22).toFixed(1)}px ${(y * 0.3).toFixed(1)}px`;
    });
    b.addEventListener('pointerleave', () => { b.style.translate = ''; });
  });
})();

// ===== Field-notes rail: drag, arrows, progress =====
(() => {
  const rail = document.querySelector('.rail');
  if (!rail) return;
  const bar = document.querySelector('.rail-bar span');
  const step = () => (rail.querySelector('.note')?.getBoundingClientRect().width || 300) + 20;
  document.querySelectorAll('[data-rail]').forEach(b => b.addEventListener('click', () => rail.scrollBy({ left: +b.dataset.rail * step() * 2, behavior: reduce ? 'auto' : 'smooth' })));
  const upd = () => {
    const max = rail.scrollWidth - rail.clientWidth;
    const vis = rail.clientWidth / rail.scrollWidth;
    if (bar) { bar.style.width = (vis * 100) + '%'; bar.style.transform = `translateX(${max > 0 ? (rail.scrollLeft / max) * ((1 - vis) / vis) * 100 : 0}%)`; }
  };
  rail.addEventListener('scroll', upd, { passive: true }); addEventListener('resize', upd); upd();
  let down = false, sx = 0, sl = 0, moved = false;
  rail.addEventListener('pointerdown', e => { if (e.pointerType !== 'mouse') return; down = true; moved = false; sx = e.clientX; sl = rail.scrollLeft; });
  addEventListener('pointermove', e => { if (!down) return; const dx = e.clientX - sx; if (Math.abs(dx) > 5) { moved = true; rail.classList.add('dragging'); } rail.scrollLeft = sl - dx; });
  addEventListener('pointerup', () => { if (!down) return; down = false; setTimeout(() => rail.classList.remove('dragging'), 0); });
  rail.addEventListener('click', e => { if (moved) { e.stopPropagation(); e.preventDefault(); moved = false; } }, true);
  rail.addEventListener('keydown', e => { if (e.key === 'ArrowRight') rail.scrollBy({ left: step() }); if (e.key === 'ArrowLeft') rail.scrollBy({ left: -step() }); });
})();

// ===== Quote rotator =====
(() => {
  const qs = [...document.querySelectorAll('.q')];
  const dots = document.querySelector('.quote-dots');
  if (!qs.length || !dots) return;
  let i = 0, timer;
  const show = n => {
    i = (n + qs.length) % qs.length;
    qs.forEach((q, k) => q.classList.toggle('is-active', k === i));
    [...dots.children].forEach((d, k) => d.setAttribute('aria-selected', k === i));
  };
  const restart = () => { clearInterval(timer); if (!reduce) timer = setInterval(() => show(i + 1), 6500); };
  qs.forEach((q, k) => {
    const b = document.createElement('button');
    b.type = 'button'; b.setAttribute('role', 'tab'); b.setAttribute('aria-label', 'Quote ' + (k + 1));
    b.addEventListener('click', () => { show(k); restart(); });
    dots.appendChild(b);
  });
  show(0); restart();
})();

// ===== Share with a friend =====
(() => {
  const btn = document.querySelector('[data-share]');
  if (!btn) return;
  const status = document.querySelector('.share-status');
  const url = location.href.split('#')[0];
  const data = { title: 'Red Moon by Aaron Holden', text: 'When the Black Rain falls, the dead come knocking. Check out Red Moon, Book One of The Luna Odyssey.', url };
  btn.addEventListener('click', async () => {
    try {
      if (navigator.share) { await navigator.share(data); return; }
      await navigator.clipboard.writeText(`${data.text} ${url}`);
      status.textContent = 'Link copied. Paste it to a friend.';
    } catch (e) {
      if (e && e.name === 'AbortError') return;
      status.textContent = 'Copy this link to share: ' + url;
    }
  });
})();

// ===== Lightbox =====
(() => {
  const lb = document.querySelector('.lightbox');
  if (!lb) return;
  const img = lb.querySelector('img'), cap = lb.querySelector('.lb-cap'), close = lb.querySelector('.lb-close');
  let opener = null;
  const open = el => {
    const src = el.querySelector('img'), label = el.querySelector('figcaption, span');
    img.src = src.currentSrc || src.src; img.alt = src.alt;
    cap.textContent = label ? label.textContent : '';
    opener = el; lb.hidden = false; document.body.style.overflow = 'hidden'; close.focus();
  };
  const shut = () => { lb.hidden = true; document.body.style.overflow = ''; if (opener) opener.focus(); };
  document.querySelectorAll('.zoomable').forEach(el => {
    el.tabIndex = 0; el.setAttribute('role', 'button');
    el.addEventListener('click', () => open(el));
    el.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(el); } });
  });
  close.addEventListener('click', shut);
  lb.addEventListener('click', e => { if (e.target === lb) shut(); });
  addEventListener('keydown', e => { if (e.key === 'Escape' && !lb.hidden) shut(); });
})();

// ===== External links: open reliably, even inside a sandboxed preview frame =====
(() => {
  const toast = document.createElement('div');
  toast.className = 'ext-toast'; toast.setAttribute('role', 'status'); toast.hidden = true;
  document.body.appendChild(toast);
  let tTimer;
  const showToast = url => {
    toast.innerHTML = '';
    const p = document.createElement('p'); p.textContent = 'Your browser blocked the new tab. Open the link here:';
    const a = document.createElement('a'); a.href = url; a.textContent = url.replace(/^https?:\/\//, '').replace(/\/$/, ''); a.target = '_top'; a.rel = 'noopener';
    const b = document.createElement('button'); b.type = 'button'; b.textContent = 'Copy link';
    b.addEventListener('click', async () => { try { await navigator.clipboard.writeText(url); b.textContent = 'Copied'; } catch { b.textContent = 'Copy failed'; } });
    const x = document.createElement('button'); x.type = 'button'; x.className = 'x'; x.setAttribute('aria-label', 'Close'); x.textContent = '×';
    x.addEventListener('click', () => { toast.hidden = true; });
    toast.append(p, a, b, x); toast.hidden = false;
    clearTimeout(tTimer); tTimer = setTimeout(() => { toast.hidden = true; }, 12000);
  };
  document.addEventListener('click', e => {
    const a = e.target.closest('a[target="_blank"]');
    if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey) return;
    const url = a.href;
    if (!/^https?:/.test(url) || url.startsWith(location.origin + '/') && !/amazon|eppublishers/.test(url)) return;
    e.preventDefault();
    let w = null;
    try { w = window.open(url, '_blank'); if (w) w.opener = null; } catch {}
    if (w) return;
    try { window.top.location.href = url; return; } catch {}
    showToast(url);
  });
})();

// ===== Excerpt expand =====
(() => {
  const btn = document.querySelector('.ex-toggle'), body = document.getElementById('ex-body');
  if (!btn || !body) return;
  btn.addEventListener('click', () => {
    const open = !body.classList.contains('open');
    body.classList.toggle('open', open);
    btn.setAttribute('aria-expanded', open);
    btn.textContent = open ? 'Show less' : 'Keep reading';
    if (!open) body.closest('.excerpt-page').scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  });
})();

// ===== Back to top with progress ring =====
(() => {
  const tt = document.querySelector('.to-top'); if (!tt) return;
  const ring = tt.querySelector('.tt-ring'); let tick = false;
  const upd = () => {
    const max = document.documentElement.scrollHeight - innerHeight;
    const p = max > 0 ? scrollY / max : 0;
    ring.style.strokeDashoffset = (132 * (1 - p)).toFixed(1);
    tt.classList.toggle('show', scrollY > 700); tick = false;
  };
  addEventListener('scroll', () => { if (!tick) { requestAnimationFrame(upd); tick = true; } }, { passive: true });
  tt.addEventListener('click', e => { e.preventDefault(); scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }); });
  upd();
})();

// ===== Intro: click to skip, then release =====
(() => {
  const intro = document.getElementById('intro');
  if (!intro || !document.documentElement.classList.contains('intro')) return;
  let timer;
  const onKey = e => { if (e.key === 'Escape' || ((e.key === 'Enter' || e.key === ' ') && e.target === intro)) { e.preventDefault(); done(); } };
  const done = () => { clearTimeout(timer); document.removeEventListener('keydown', onKey); document.documentElement.classList.remove('intro'); intro.remove(); };
  intro.setAttribute('role', 'button'); intro.setAttribute('tabindex', '0'); intro.setAttribute('aria-label', 'Skip introduction');
  document.addEventListener('keydown', onKey);
  intro.addEventListener('click', () => { intro.classList.add('skip'); setTimeout(done, 650); });
  timer = setTimeout(done, 2200);
})();


// ===== Custom cursor (mouse/trackpad only) =====
(() => {
  if (!finePointer || reduce) return;
  const dot = document.createElement('div'), ring = document.createElement('div');
  dot.className = 'cur-dot'; ring.className = 'cur-ring'; document.body.append(dot, ring);
  let x = innerWidth / 2, y = innerHeight / 2, rx = x, ry = y;
  addEventListener('pointermove', e => { x = e.clientX; y = e.clientY; document.documentElement.classList.add('cur-on'); dot.style.transform = `translate(${x}px,${y}px)`; }, { passive: true });
  document.addEventListener('pointerleave', () => document.documentElement.classList.remove('cur-on'));
  addEventListener('pointerdown', () => document.documentElement.classList.add('cur-down'));
  addEventListener('pointerup', () => document.documentElement.classList.remove('cur-down'));
  document.addEventListener('pointerover', e => { document.documentElement.classList.toggle('cur-hover', !!e.target.closest('a, button, .zoomable, .char, .note, [role="button"]')); });
  let raf = 0;
  const tick = () => { rx += (x - rx) * 0.18; ry += (y - ry) * 0.18; ring.style.transform = `translate(${rx}px,${ry}px)`; raf = (Math.abs(x - rx) + Math.abs(y - ry) > 0.3) ? requestAnimationFrame(tick) : 0; };
  addEventListener('pointermove', () => { if (!raf) raf = requestAnimationFrame(tick); }, { passive: true });
  tick();
})();

// ===== Nav bar: keep the active link visible in the swipeable row =====
(() => {
  const nav = document.querySelector('.nav'); if (!nav) return;
  nav.scrollLeft = 0;
  new MutationObserver(() => {
    const a = nav.querySelector('[aria-current]');
    if (a && nav.scrollWidth > nav.clientWidth) nav.scrollTo({ left: a.offsetLeft - nav.clientWidth / 2 + a.offsetWidth / 2, behavior: reduce ? 'auto' : 'smooth' });
  }).observe(nav, { subtree: true, attributes: true, attributeFilter: ['aria-current'] });
})();

// ===== Author-note toggle =====
(() => {
  const t = document.querySelector('.issue-toggle'), body = document.getElementById('issue-body');
  if (t && body) t.addEventListener('click', () => {
    const open = !body.classList.contains('open'); body.classList.toggle('open', open);
    t.setAttribute('aria-expanded', open); t.textContent = open ? 'Show less' : 'Read the full issue';
  });
})();

// ===== In-page links: land exactly on the section =====
// Images and animated sections above the target finish loading while the page
// scrolls, which pushes the target down. Re-aim once the scroll settles so the
// nav links (Shop, Contact, ...) always land on the right section.
(() => {
  const behavior = (typeof reduce !== 'undefined' && reduce) ? 'auto' : 'smooth';
  const offset = () => parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) || 0;
  const topOf = el => el.getBoundingClientRect().top + scrollY - offset();
  const land = (el, tries = 4) => {
    scrollTo({ top: topOf(el), behavior });
    let last = -1, still = 0;
    const check = () => {
      if (Math.abs(scrollY - last) < 1) still++; else { still = 0; last = scrollY; }
      if (still < 3) return setTimeout(check, 120);
      const maxY = document.documentElement.scrollHeight - innerHeight;
      if (tries > 1 && Math.abs(el.getBoundingClientRect().top - offset()) > 2 && scrollY < maxY - 1) land(el, tries - 1);
    };
    setTimeout(check, 120);
  };
  document.addEventListener('click', e => {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const a = e.target.closest('a[href*="#"]'); if (!a) return;
    const u = new URL(a.href, location.href);
    if (u.origin !== location.origin || u.pathname !== location.pathname || u.hash.length < 2) return;
    const el = document.getElementById(decodeURIComponent(u.hash.slice(1))); if (!el) return;
    e.preventDefault();
    history.pushState(null, '', u.pathname + u.search + u.hash);
    land(el);
  });
  // Arriving from another page (e.g. /#shop from a product page)
  if (location.hash.length > 1) {
    const el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
    if (el) addEventListener('load', () => land(el, 3), { once: true });
  }
})();

// ===== v7: top bar hover pill follows the pointer =====
(() => {
  const nav = document.querySelector('.tb-nav'); if (!nav) return;
  const ink = nav.querySelector('.nav-ink'); if (!ink) return;
  const place = a => { if (!a) { ink.style.opacity = 0; return; } ink.style.width = a.offsetWidth + 'px'; ink.style.transform = `translateX(${a.offsetLeft}px)`; ink.style.opacity = 1; };
  nav.querySelectorAll(':scope > a, :scope > .tb-dd > a').forEach(a => a.addEventListener('mouseenter', () => place(a)));
  nav.querySelectorAll('[data-dd]').forEach(dd => { const t = dd.querySelector('.tb-dd-trigger'); const set = v => t && t.setAttribute('aria-expanded', v); dd.addEventListener('mouseenter', () => set('true')); dd.addEventListener('mouseleave', () => set('false')); dd.addEventListener('focusin', () => set('true')); dd.addEventListener('focusout', e => { if (!dd.contains(e.relatedTarget)) set('false'); }); dd.addEventListener('keydown', e => { if (e.key === 'Escape') { set('false'); t && t.focus(); document.activeElement && document.activeElement.blur(); } }); });
  nav.addEventListener('mouseleave', () => place(nav.querySelector('[aria-current]')));
})();
} catch (e) { setTimeout(function () { throw e; }); }
/* ==== luna-cart.js ==== */
try {
// ===== Luna Odyssey storefront: variant picker, gallery, AJAX add-to-cart =====
(() => {
  const root = document.querySelector('[data-product]'); if (!root) return;
  const variants = JSON.parse(root.querySelector('[data-variants]').textContent);
  const form = root.querySelector('[data-product-form]'), idInput = root.querySelector('[data-variant-id]');
  const price = root.querySelector('[data-price]'), add = root.querySelector('[data-add]'), status = root.querySelector('[data-status]');
  const main = root.querySelector('.pdp-main img');
  const express = root.querySelector('[data-express]');
  const setExpress = on => { if (express) express.hidden = !on; };
  const isSoon = v => root.dataset.soonAll === 'true' || (!!v && (root.dataset.soon || '').includes('|' + v.title + '|'));
  const money = c => '$' + (c / 100).toFixed(2);
  const preMapEl = root.querySelector('[data-pre-map]'); let preMap = {}; try { if (preMapEl) preMap = JSON.parse(preMapEl.textContent) || {}; } catch (_) {}
  const sized = src => { try { const u = new URL(src, location.href); u.searchParams.set('width', innerWidth < 900 ? '900' : '1400'); return u.href; } catch (_) { return src; } };
  const groups = [...root.querySelectorAll('.pdp-opt')];
  const pick = () => groups.map(g => (g.querySelector('input:checked') || {}).value);
  const update = () => {
    const sel = pick(); const v = variants.find(v => v.options.every((o, i) => o === sel[i]));
    if (!v) { add.disabled = true; add.textContent = 'Unavailable'; setExpress(false); return; }
    idInput.value = v.id; price.innerHTML = money(v.price) + (v.compare_at_price > v.price ? ` <s>${money(v.compare_at_price)}</s>` : '');
    const preEl = root.querySelector('[data-pre]');
    if (isSoon(v)) { add.disabled = true; add.textContent = 'Coming soon'; setExpress(false); if (preEl) preEl.hidden = true; }
    else {
    if (preEl) preEl.hidden = false;
    add.disabled = !v.available; add.textContent = v.available ? (add.dataset.label || 'Add to cart') : 'Sold out';
    const pp = root.querySelector('[data-pre-price]'), pc = root.querySelector('[data-pre-pct]'), pm = preMap[v.id]; if (pp && pm) { pp.textContent = pm[0]; if (pc) pc.textContent = pm[1]; } setExpress(v.available);
    }
    if (v.featured_image && main) { main.src = sized(v.featured_image.src); main.removeAttribute('srcset'); const fid = String(v.featured_image.src).split('?')[0].split('/').pop(); root.querySelectorAll('.pdp-thumb').forEach(x => x.classList.toggle('on', (x.dataset.src || '').split('?')[0].split('/').pop().replace(/_\d+x\d*/, '') === fid.replace(/_\d+x\d*/, ''))); }
    const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u);
  };
  groups.forEach(g => g.addEventListener('change', update));
  root.querySelectorAll('.pdp-thumb').forEach(b => b.addEventListener('click', () => {
    root.querySelectorAll('.pdp-thumb').forEach(x => x.classList.remove('on')); b.classList.add('on');
    if (main) { main.src = b.dataset.src; main.removeAttribute('srcset'); }
  }));
  form.addEventListener('submit', async e => {
    if (e.submitter && e.submitter.name !== 'add') return;
    e.preventDefault(); add.disabled = true; const label = add.textContent; add.textContent = 'Adding…'; status.textContent = '';
    try {
      const r = await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      const d = await r.json(); if (!r.ok) throw new Error(d.description || d.message || 'Could not add to cart.');
      const c = await (await fetch('/cart.js')).json();
      document.querySelectorAll('[data-cart-count]').forEach(n => { n.textContent = c.item_count; n.hidden = c.item_count === 0; });
      status.innerHTML = (add.dataset.label === 'Pre-order now' ? 'Pre-order added to your cart. Your pre-order discount is applied at checkout. ' : 'Added to your cart. ') + `<a href="/cart">View cart and check out</a>`;
    } catch (err) { status.textContent = err.message; }
    finally { add.textContent = label; const cur = variants.find(x => String(x.id) === String(idInput.value)); add.disabled = isSoon(cur) || !(cur ? cur.available : true); }
  });
})();
} catch (e) { setTimeout(function () { throw e; }); }
/* ==== luna-extra.js ==== */
try {
/* Release-day countdown: Tue Apr 13 2027, 12:00 AM Mountain (06:00 UTC) */
(function(){
  const box = document.querySelector('[data-launch-clock]'); if (!box) return;
  const REL = Date.UTC(2027, 3, 13, 6, 0, 0);
  const els = {}; ['d','h','m','s'].forEach(k => els[k] = box.querySelector('[data-lc="'+k+'"]'));
  const label = box.querySelector('[data-lc-label]');
  const pad = n => String(n).padStart(2, '0');
  let last = {};
  function set(k, v){ const el = els[k]; if (!el || last[k] === v) return; last[k] = v; el.textContent = v; el.classList.remove('tick'); void el.offsetWidth; el.classList.add('tick'); }
  function tick(){
    const t = REL - Date.now();
    if (t <= 0) { box.classList.add('is-live'); if (label) label.innerHTML = '<strong>Red Moon is out now</strong>, in every edition.'; return false; }
    set('d', String(Math.floor(t/864e5))); set('h', pad(Math.floor(t/36e5)%24)); set('m', pad(Math.floor(t/6e4)%60)); set('s', pad(Math.floor(t/1e3)%60));
    return true;
  }
  if (tick()) { const id = setInterval(() => { if (!tick()) clearInterval(id); }, 1000); }
})();

/* Storm pass: scroll-driven clouds and lightning */
(function(){
  const passes = [...document.querySelectorAll('[data-storm]')]; if (!passes.length) return;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  let ticking = false;
  function update(){
    ticking = false; const vh = innerHeight;
    passes.forEach(el => {
      const r = el.getBoundingClientRect();
      const p = Math.min(1, Math.max(0, (vh - r.top) / (vh + r.height)));
      el.style.setProperty('--p', p.toFixed(3));
      el._vis = r.bottom > 0 && r.top < vh;
    });
  }
  addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
  addEventListener('resize', update); update();
  if (reduce) return;
})();

/* Black cloud veil: thick storm cloud that tears apart and scatters on scroll */
(function(){
  const veil = document.querySelector('[data-veil]'); if (!veil) return;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const canvas = veil.querySelector('.veil-cloud'); const ctx = canvas.getContext('2d');
  let W = 0, H = 0, DPR = 1, puffs = [], motes = [], p = 0, shown = 0, visible = false, flash = 0, nextFlash = 0;
  function sprite(seed){
    const c = document.createElement('canvas'); c.width = c.height = 256; const g = c.getContext('2d');
    let s = seed; const rnd = () => (s = (s * 9301 + 49297) % 233280) / 233280;
    for (let i = 0; i < 18; i++){
      const x = 128 + (rnd() - .5) * 120, y = 128 + (rnd() - .5) * 96, r = 34 + rnd() * 64;
      const l = Math.floor(3 + rnd() * 20);
      const grd = g.createRadialGradient(x - r * .25, y - r * .3, r * .1, x, y, r);
      grd.addColorStop(0, `rgba(${l + 10},${l + 8},${l + 8},.97)`); grd.addColorStop(.5, `rgba(${l},${Math.max(0,l - 1)},${Math.max(0,l - 1)},.8)`); grd.addColorStop(1, 'rgba(2,2,2,0)');
      g.fillStyle = grd; g.beginPath(); g.arc(x, y, r, 0, Math.PI * 2); g.fill();
    }
    // red underglow from the moon on the cloud's belly
    const rim = g.createRadialGradient(128, 200, 10, 128, 190, 120);
    rim.addColorStop(0, 'rgba(140,24,28,.14)'); rim.addColorStop(1, 'rgba(150,28,32,0)');
    g.globalCompositeOperation = 'source-atop'; g.fillStyle = rim; g.fillRect(0, 0, 256, 256);
    return c;
  }
  const sprites = [1, 7, 13, 21, 34].map(sprite);
  function build(){
    DPR = Math.min(2, devicePixelRatio || 1);
    W = canvas.clientWidth; H = canvas.clientHeight;
    canvas.width = W * DPR; canvas.height = H * DPR; ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
    const cx = W / 2, cy = H / 2, diag = Math.hypot(W, H);
    const n = Math.round(Math.min(230, 110 + W * H / 9000));
    puffs = [];
    for (let i = 0; i < n; i++){
      const x = Math.random() * W * 1.2 - W * .1, y = Math.random() * H * 1.2 - H * .1;
      let dx = x - cx + (Math.random() - .5) * 80, dy = y - cy + (Math.random() - .5) * 80; const d = Math.hypot(dx, dy) || 1; dx /= d; dy /= d;
      puffs.push({ x, y, dx, dy, r: (.16 + Math.random() * .2) * Math.max(W, H) * .5, sp: diag * (.7 + Math.random() * 1.1), rot: Math.random() * 6.28, vr: (Math.random() - .5) * 1.4, s: sprites[i % sprites.length], delay: Math.min(1, d / (diag / 2)) * .3 + Math.random() * .1, wob: Math.random() * 6.28 });
    }
    motes = [];
    for (let i = 0; i < 260; i++){
      const a = Math.random() * 6.28, rr = Math.random() * .45 * diag;
      motes.push({ x: cx + Math.cos(a) * rr * .8, y: cy + Math.sin(a) * rr * .5, a, v: diag * (.4 + Math.random() * 1.1), sz: .6 + Math.random() * 2.2, d: Math.random() * .3 });
    }
  }
  const ease = t => t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  let vraf = 0;
  const kickV = () => { if (!vraf) vraf = requestAnimationFrame(frame); };
  function frame(now){
    if (!visible && Math.abs(shown - p) < .001) { vraf = 0; return; }
    vraf = requestAnimationFrame(frame);
    shown += (p - shown) * .12;
    const t = now / 1000;
    ctx.clearRect(0, 0, W, H);
    const base = Math.max(0, .85 - shown * 6);
    if (base > 0){ ctx.fillStyle = `rgba(4,3,3,${base})`; ctx.fillRect(0, 0, W, H); }
    for (const q of puffs){
      const k = ease(Math.min(1, Math.max(0, (shown - .04 - q.delay) / .45)));
      const alpha = Math.pow(1 - k, 1.7);
      if (alpha <= .01) continue;
      const wob = Math.sin(t * .4 + q.wob) * 14 * (1 - k);
      const x = q.x + q.dx * q.sp * k + wob, y = q.y + q.dy * q.sp * k * .8 - k * 60 + Math.cos(t * .3 + q.wob) * 10;
      const r = q.r * (1 + k * .35);
      ctx.save(); ctx.globalAlpha = alpha; ctx.translate(x, y); ctx.rotate(q.rot + q.vr * k + Math.sin(t * .1 + q.wob) * .05);
      ctx.drawImage(q.s, -r, -r, r * 2, r * 2); ctx.restore();
    }
    // Scattering ash and droplets
    if (shown > .04){
      ctx.fillStyle = 'rgba(12,10,9,1)';
      for (const m of motes){
        const k = Math.min(1, Math.max(0, (shown - .08 - m.d) / .6)); if (k <= 0 || k >= 1) continue;
        ctx.globalAlpha = (1 - k) * .9;
        const x = m.x + Math.cos(m.a) * m.v * k, y = m.y + Math.sin(m.a) * m.v * k * .7 + k * k * 120;
        ctx.fillRect(x, y, m.sz, m.sz * 2.4);
      }
      ctx.globalAlpha = 1;
    }
    // Lightning glowing inside the cloud while it's still thick
    if (!reduce && shown < .55 && visible){
      if (now > nextFlash){ flash = 1; nextFlash = now + 2500 + Math.random() * 4000; veil._fx = .25 + Math.random() * .5; }
      if (flash > .02){
        const g = ctx.createRadialGradient(W * veil._fx, H * .42, 0, W * veil._fx, H * .42, Math.max(W, H) * .5);
        g.addColorStop(0, `rgba(255,236,230,${.32 * flash * (1 - shown * 1.6)})`); g.addColorStop(.4, `rgba(201,57,61,${.18 * flash})`); g.addColorStop(1, 'rgba(0,0,0,0)');
        ctx.globalCompositeOperation = 'lighter'; ctx.fillStyle = g; ctx.fillRect(0, 0, W, H); ctx.globalCompositeOperation = 'source-over';
        flash *= Math.random() < .12 ? 1.6 : .86; if (flash > 1) flash = 1;
      }
    }
  }
  function onScroll(){
    const r = veil.getBoundingClientRect(), vh = innerHeight;
    visible = r.bottom > 0 && r.top < vh;
    p = Math.min(1, Math.max(0, -r.top / Math.max(1, r.height - vh)));
    veil.style.setProperty('--p', p.toFixed(3));
  }
  if (reduce){ veil.style.setProperty('--p', 1); return; }
  build(); onScroll(); shown = p;
  addEventListener('scroll', () => { onScroll(); kickV(); }, { passive: true });
  addEventListener('resize', () => { build(); onScroll(); kickV(); });
  kickV();
})();

/* Black Rain FX: ink-black rain lit red by the moon, forked lightning, wind gusts, splashes and ripples */
(function(){
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const mobile = innerWidth < 700;
  function BlackRain(canvas, host, o){
    const ctx = canvas.getContext('2d');
    let W = 0, H = 0, dpr = 1, drops = [], splash = [], rings = [], bolt = null, nextBolt = performance.now() + (o.firstBolt || 2500), flash = 0, visible = false, last = 0;
    const mk = init => { const z = Math.pow(Math.random(), 1.4) * .85 + .15;
      return { x: Math.random() * (W + 300) - 150, y: init ? Math.random() * H : -Math.random() * H * .4 - 30, z,
        l: 14 + z * 52, v: 900 + z * 1500, lw: .5 + z * 1.6, b: z < .45 ? 0 : z < .75 ? 1 : 2 }; };
    function resize(){
      dpr = Math.min(2, devicePixelRatio || 1); W = canvas.clientWidth; H = canvas.clientHeight; if (!W || !H) return;
      canvas.width = W * dpr; canvas.height = H * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      const n = Math.round(Math.min(o.max || 420, W * H / (o.dens || 2600)) * (mobile ? .8 : 1));
      drops = Array.from({ length: n }, () => mk(true));
    }
    function fork(x, y, ang, len, depth, out){
      const pts = [[x, y]]; let steps = 6 + (Math.random() * 6 | 0);
      for (let i = 0; i < steps; i++){
        ang += (Math.random() - .5) * .9; const seg = len / steps * (.6 + Math.random() * .8);
        x += Math.sin(ang) * seg; y += Math.cos(ang) * seg; pts.push([x, y]);
        if (depth < 2 && Math.random() < .32) fork(x, y, ang + (Math.random() < .5 ? -1 : 1) * (.5 + Math.random() * .6), len * .45, depth + 1, out);
      }
      out.push({ pts, w: depth ? 1.1 / depth : 2.6 });
    }
    function makeBolt(){
      const x = W * (.18 + Math.random() * .64), segs = [];
      fork(x, -10, (Math.random() - .5) * .4, H * (.55 + Math.random() * .35), 0, segs);
      return { segs, x, t: 0, flick: 2 + (Math.random() * 3 | 0) };
    }
    function drawBolt(b, a){
      ctx.save(); ctx.lineCap = 'round'; ctx.lineJoin = 'round'; ctx.globalCompositeOperation = 'lighter';
      for (const pass of [[10, 'rgba(226,71,75,', .28], [4, 'rgba(255,190,180,', .45], [1, 'rgba(255,248,244,', 1]]){
        for (const s of b.segs){
          ctx.strokeStyle = pass[1] + (pass[2] * a) + ')'; ctx.lineWidth = s.w * pass[0];
          ctx.beginPath(); s.pts.forEach(([x, y], i) => i ? ctx.lineTo(x, y) : ctx.moveTo(x, y)); ctx.stroke();
        }
      }
      ctx.restore();
    }
    const BODY = ['rgba(8,5,5,.28)', 'rgba(6,4,4,.5)', 'rgba(3,2,2,.78)'];
    const LIT = ['rgba(214,92,92,.16)', 'rgba(232,108,104,.3)', 'rgba(246,140,132,.46)'];
    let raf = 0;
    const kick = () => { if (!raf && visible && !document.hidden) { last = 0; raf = requestAnimationFrame(frame); } };
    function frame(now){
      if (!visible || document.hidden) { raf = 0; return; }
      raf = requestAnimationFrame(frame);
      const dt = Math.min(.05, (now - (last || now)) / 1000); last = now;
      if (!W) return;
      const k = Math.max(0, Math.min(1, o.intensity ? o.intensity() : 1));
      ctx.clearRect(0, 0, W, H);
      if (k <= .01 && !bolt) return;
      const t = now / 1000;
      const gust = Math.sin(t * .55) * .5 + Math.sin(t * 1.7 + 1) * .25 + Math.max(0, Math.sin(t * .23)) * .9;
      const wind = -180 - gust * 260;            // px/s sideways: the storm leans left, harder in gusts
      const live = Math.round(drops.length * (.25 + .75 * k));
      const ground = H - 4;
      const paths = [new Path2D(), new Path2D(), new Path2D()], lit = [new Path2D(), new Path2D(), new Path2D()];
      for (let i = 0; i < live; i++){
        const d = drops[i]; const vx = wind * (.5 + d.z * .7);
        d.y += d.v * dt; d.x += vx * dt;
        const sx = vx / d.v * d.l;
        paths[d.b].moveTo(d.x - sx, d.y - d.l); paths[d.b].lineTo(d.x, d.y);
        lit[d.b].moveTo(d.x - sx + .9, d.y - d.l * .7); lit[d.b].lineTo(d.x + .9, d.y);
        const floor = o.floor ? ground - (1 - d.z) * H * o.floor : ground;
        if (d.y > floor){
          if (o.splash && d.z > .55 && splash.length < 220){
            for (let j = 0; j < 3; j++) splash.push({ x: d.x, y: floor, vx: (Math.random() - .6) * 120 * d.z, vy: -(80 + Math.random() * 160) * d.z, life: 1, r: .7 + d.z });
            if (rings.length < 60) rings.push({ x: d.x, y: floor, r: 1, life: 1, z: d.z });
          }
          Object.assign(d, mk(false));
        }
        if (d.x < -160) d.x += W + 300;
      }
      ctx.lineCap = 'round';
      for (let b = 0; b < 3; b++){
        ctx.lineWidth = [.7, 1.2, 1.9][b]; ctx.strokeStyle = BODY[b]; ctx.stroke(paths[b]);
        ctx.lineWidth = [.4, .6, .8][b]; ctx.strokeStyle = LIT[b]; ctx.stroke(lit[b]);
      }
      for (let i = splash.length - 1; i >= 0; i--){
        const s = splash[i]; s.x += s.vx * dt; s.y += s.vy * dt; s.vy += 900 * dt; s.life -= dt * 2.6;
        if (s.life <= 0){ splash.splice(i, 1); continue; }
        ctx.fillStyle = `rgba(232,110,104,${.55 * s.life})`; ctx.fillRect(s.x, s.y, s.r, s.r * 1.6);
      }
      ctx.lineWidth = .8;
      for (let i = rings.length - 1; i >= 0; i--){
        const r = rings[i]; r.r += dt * 26 * r.z; r.life -= dt * 2;
        if (r.life <= 0){ rings.splice(i, 1); continue; }
        ctx.strokeStyle = `rgba(226,90,90,${.35 * r.life})`; ctx.beginPath(); ctx.ellipse(r.x, r.y, r.r * 2.2, r.r * .5, 0, 0, 6.283); ctx.stroke();
      }
      if (o.bolts && k > .25){
        if (!bolt && now > nextBolt){
          bolt = makeBolt(); nextBolt = now + (o.gap || 5000) + Math.random() * (o.gap || 5000);
          host.style.setProperty('--fx', (bolt.x / W * 100).toFixed(0) + '%');
          host.classList.remove('flash'); void host.offsetWidth; host.classList.add('flash');
          try { if (window.lunaThunder) setTimeout(window.lunaThunder, 250 + Math.random() * 700); } catch(e) {}
        }
      }
      if (bolt){
        bolt.t += dt;
        const ph = bolt.t * 9; const a = bolt.t > .9 ? 0 : Math.max(0, Math.cos(ph * bolt.flick) * .5 + .5) * (1 - bolt.t / .9);
        if (a > .02){
          ctx.fillStyle = `rgba(255,228,222,${.10 * a})`; ctx.fillRect(0, 0, W, H);
          drawBolt(bolt, a);
        }
        if (bolt.t > .9) bolt = null;
      }
    }
    resize(); addEventListener('resize', resize);
    new IntersectionObserver(es => es.forEach(e => { visible = e.isIntersecting; if (visible) resize(); kick(); }), { rootMargin: '100px' }).observe(host);
    document.addEventListener('visibilitychange', kick);
  }
  document.querySelectorAll('[data-storm]').forEach(el => {
    const c = el.querySelector('.sp-rain'); if (!c) return;
    BlackRain(c, el, { dens: 850, max: 700, splash: true, bolts: true, gap: 4200, firstBolt: 1400, floor: .12,
      intensity: () => { const p = parseFloat(el.style.getPropertyValue('--p')) || 0; return .45 + .55 * Math.sin(Math.PI * Math.min(1, p * 1.1)); } });
  });
  const veil = document.querySelector('[data-veil]');
  if (veil){
    const c = veil.querySelector('.veil-rain');
    if (c) BlackRain(c, veil.querySelector('.veil-sticky'), { dens: 1300, max: 600, splash: true, bolts: true, gap: 5200, firstBolt: 900, floor: .1,
      intensity: () => { const p = parseFloat(veil.style.getPropertyValue('--p')) || 0; return Math.min(1, .35 + p * 1.4) * (p > .92 ? (1 - p) * 12.5 : 1); } });
  }
})();

/* Author feature: the portrait frame rises into place as you scroll to it */
(function(){
  const f = document.querySelector('[data-au-frame]'); if (!f) return;
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  let raf = 0;
  const upd = () => { raf = 0; const r = f.getBoundingClientRect(), vh = innerHeight;
    const k = Math.min(1, Math.max(0, (vh - r.top) / (vh * .55)));
    f.style.setProperty('--auf', (1 - Math.pow(1 - k, 3)).toFixed(3)); };
  addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(upd); }, { passive: true });
  addEventListener('resize', upd); upd();
})();
} catch (e) { setTimeout(function () { throw e; }); }
/* ==== luna-v10.js ==== */
try {
/* The Luna Odyssey v10: free chapter read-along, polish and home link, carried over from the reader site */
/* ===== Free enhanced Chapter 1: read-along preview + film ===== */
(() => {
  const v = document.querySelector('[data-free-video]'), vs = document.querySelector('[data-free-video-sound]');
  if (v) {
    const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const loadVideo = () => { if (v.dataset.src && !v.getAttribute('src')) { v.src = v.dataset.src; v.preload = 'metadata'; v.load(); } };
    if ('IntersectionObserver' in window) {
      const near = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { loadVideo(); near.unobserve(v); } }), { rootMargin: '300px' });
      near.observe(v);
      if (!reduce) new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting && e.intersectionRatio >= .35 && !document.hidden) { loadVideo(); v.play().catch(() => {}); } else v.pause(); }), { threshold: [0,.35] }).observe(v);
    } else loadVideo();
    document.addEventListener('visibilitychange', () => { if (document.hidden) document.querySelectorAll('video').forEach(o => o.pause()); });
    const sync = () => { if (!vs) return; vs.setAttribute('aria-pressed', String(!v.muted)); vs.textContent = v.muted ? 'Sound on' : 'Sound off'; };
    const toggle = () => { loadVideo(); v.muted = !v.muted; if (!v.muted) { document.querySelectorAll('video').forEach(o => { if (o !== v) o.muted = true; }); v.play().catch(() => {}); } sync(); };
    v.addEventListener('volumechange', sync);
    vs && vs.addEventListener('click', toggle);
    v.addEventListener('click', toggle);
  }
  const ra = document.getElementById('readalong'); if (!ra) return;
  const audio = ra.querySelector('audio'), btn = ra.querySelector('.ra-play'), bar = ra.querySelector('.ra-bar span'),
        barWrap = ra.querySelector('.ra-bar'), tm = ra.querySelector('.ra-time'), box = ra.querySelector('[data-ra-text]');
  const words = []; let dur = 89.3, cur = -1, loaded = false;
  const fmt = s => `${Math.floor(s / 60)}:${String(Math.floor(s % 60)).padStart(2, '0')}`;
  const load = () => loaded ? Promise.resolve() : Promise.resolve(JSON.parse(document.getElementById('ra-words').textContent)).then(d => {
    loaded = true; dur = d.dur; box.textContent = '';
    d.paras.forEach(p => { const el = document.createElement('p');
      p.forEach(([w, b]) => { const s = document.createElement('span'); s.textContent = w; s.dataset.b = b; words.push(s); el.append(s, ' '); });
      box.append(el); });
  });
  load();
  const paint = () => {
    const t = audio.currentTime; let i = cur;
    while (i + 1 < words.length && +words[i + 1].dataset.b <= t + .03) i++;
    while (i >= 0 && +words[i].dataset.b > t + .03) i--;
    if (i !== cur) {
      if (words[cur]) words[cur].classList.remove('on');
      const lo = Math.min(i, cur), hi = Math.max(i, cur);
      for (let k = Math.max(0, lo); k <= hi; k++) if (words[k]) words[k].classList.toggle('said', k <= i);
      cur = i; const w = words[cur];
      if (w) { w.classList.add('on');
        const top = w.offsetTop - box.offsetTop; if (top > box.scrollTop + box.clientHeight * .6 || top < box.scrollTop) box.scrollTop = top - box.clientHeight * .3; }
    }
    bar.style.transform = `scaleX(${Math.min(1, t / (audio.duration || dur))})`;
    tm.textContent = `${fmt(t)} / ${fmt(audio.duration || dur)}`;
    if (!audio.paused) requestAnimationFrame(paint);
  };
  const play = () => load().then(() => { document.querySelectorAll('audio').forEach(a => { if (a !== audio) a.pause(); }); return audio.play(); }).catch(() => {});
  btn.addEventListener('click', () => audio.paused ? play() : audio.pause());
  audio.addEventListener('play', () => { ra.classList.add('playing', 'started'); btn.setAttribute('aria-pressed', 'true'); btn.setAttribute('aria-label', 'Pause the narrated preview'); paint(); });
  audio.addEventListener('pause', () => { ra.classList.remove('playing'); btn.setAttribute('aria-pressed', 'false'); btn.setAttribute('aria-label', 'Play the narrated preview'); });
  audio.addEventListener('ended', () => { audio.currentTime = 0; paint(); });
  box.addEventListener('click', e => { const s = e.target.closest('span'); if (!s || s.dataset.b === undefined) return; audio.currentTime = +s.dataset.b; ra.classList.add('started'); paint(); if (audio.paused) play(); });
  barWrap.addEventListener('click', e => { const r = barWrap.getBoundingClientRect(); audio.currentTime = (e.clientX - r.left) / r.width * (audio.duration || dur); paint(); });
})();

/* free enhanced chapter: every Download button works. The plain file link is the default;
   when the site's own server is reachable we switch to it, since iPhone Safari saves that as a real download. */
(function(){
  const links = [...document.querySelectorAll('[data-free-epub]')]; if (!links.length) return;
  const API = '__PORT_8000__'.startsWith('__') ? 'http://localhost:8000' : '__PORT_8000__';
  const url = API + '/api/free-chapter.epub';
  const ctl = 'AbortController' in window ? new AbortController() : null;

  links.forEach(a => a.addEventListener('click', () => {
    a.classList.add('is-going');
    setTimeout(() => a.classList.remove('is-going'), 2600);
  }));
})();

/* ===== Polish: staggered grids, card spotlight + tilt, image fade-in, page transitions, embers ===== */
(function(){
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = matchMedia('(hover: hover) and (pointer: fine)').matches;

  // Staggered entrance for grids and lists
  const groups = document.querySelectorAll('.shop-grid, .ed-grid, .pre-grid, .lc-digits, .stats, .news-grid, .free-grid, .party, .shop-filters');
  if (!reduce && 'IntersectionObserver' in window){
    groups.forEach(g => [...g.children].forEach((c, i) => { c.classList.add('st'); c.style.setProperty('--si', i % 12); }));
    const io = new IntersectionObserver(es => es.forEach(e => {
      if (e.isIntersecting){ e.target.classList.add('st-in'); io.unobserve(e.target); }
    }), { rootMargin: '0px 0px -8% 0px', threshold: .05 });
    groups.forEach(g => io.observe(g));
    // Cards revealed later by filters or "show all" should appear immediately
    document.addEventListener('click', e => { if (e.target.closest('.shop-filters, [data-shop-more]')) groups.forEach(g => g.classList.add('st-in')); });
  }

  // Cursor spotlight and gentle tilt on cards
  if (fine && !reduce){
    document.querySelectorAll('.shop-card a, .ed, .pre-card, .party, .lc-digits div, .issue').forEach(card => {
      card.classList.add('glow-card');
      card.addEventListener('pointermove', e => {
        const r = card.getBoundingClientRect(), x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
        card.style.setProperty('--mx', (x * 100).toFixed(1) + '%'); card.style.setProperty('--my', (y * 100).toFixed(1) + '%');
        if (card.matches('.shop-card a')) card.style.setProperty('--tilt', `perspective(800px) rotateX(${((.5 - y) * 6).toFixed(2)}deg) rotateY(${((x - .5) * 7).toFixed(2)}deg)`);
      });
      card.addEventListener('pointerleave', () => card.style.removeProperty('--tilt'));
    });
  }

  // Lazy images fade and sharpen in as they arrive
  document.querySelectorAll('img[loading="lazy"]').forEach(img => {
    if (img.complete && img.naturalWidth) return;
    img.classList.add('fade-img');
    const done = () => img.classList.add('loaded');
    img.addEventListener('load', done, { once: true }); img.addEventListener('error', done, { once: true });
  });

  // Soft fade when moving between pages
  if (!reduce) document.addEventListener('click', e => {
    const a = e.target.closest('a[href$=".html"], a[href^="index.html"], a[href^="author.html"]');
    if (!a || a.target === '_blank' || e.metaKey || e.ctrlKey || e.shiftKey || a.hasAttribute('download')) return;
    const url = new URL(a.href, location.href); if (url.origin !== location.origin || (url.pathname === location.pathname && url.hash)) return;
    e.preventDefault(); document.documentElement.classList.add('leaving');
    setTimeout(() => { location.href = a.href; }, 380);
  });
  addEventListener('pageshow', () => document.documentElement.classList.remove('leaving'));

  // Rising embers in the launch section
  if (reduce) return;
  document.querySelectorAll('.launch, .final').forEach(sec => {
    const c = document.createElement('canvas'); c.className = 'embers'; c.setAttribute('aria-hidden', 'true'); sec.prepend(c);
    const ctx = c.getContext('2d'); let W, H, on = false, parts = [];
    const size = () => { const d = Math.min(1.5, devicePixelRatio || 1); W = c.clientWidth; H = c.clientHeight; c.width = W * d; c.height = H * d; ctx.setTransform(d, 0, 0, d, 0, 0); };
    const spawn = y => ({ x: Math.random() * W, y: y ?? H + 10, v: 12 + Math.random() * 30, r: .6 + Math.random() * 1.8, w: Math.random() * 6.28, a: .25 + Math.random() * .55 });
    size(); parts = Array.from({ length: Math.round(Math.min(70, W / 18)) }, () => spawn(Math.random() * H));
    let last = performance.now(), raf = 0;
    const kick = () => { if (!raf && on && !document.hidden) { last = performance.now(); raf = requestAnimationFrame(loop); } };
    new IntersectionObserver(es => { on = es[0].isIntersecting; kick(); }).observe(sec);
    document.addEventListener('visibilitychange', kick);
    addEventListener('resize', size);
    function loop(now){
      if (!on || document.hidden) { raf = 0; return; }
      raf = requestAnimationFrame(loop);
      const dt = Math.min(.05, (now - last) / 1000); last = now;
      ctx.clearRect(0, 0, W, H);
      for (const p of parts){
        p.y -= p.v * dt; p.w += dt * .8; const x = p.x + Math.sin(p.w) * 12;
        if (p.y < -10) Object.assign(p, spawn());
        const fade = Math.min(1, p.y / (H * .35));
        ctx.globalAlpha = p.a * fade; ctx.fillStyle = p.r > 1.6 ? '#ff6a5c' : '#e2474b';
        ctx.shadowColor = '#e2474b'; ctx.shadowBlur = 8;
        ctx.beginPath(); ctx.arc(x, p.y, p.r, 0, 6.28); ctx.fill();
      }
      ctx.globalAlpha = 1; ctx.shadowBlur = 0;
    }
  });
})();

/* ===== Logo always returns home: scroll to top on the homepage, navigate from other pages ===== */
(() => {
  const isHome = () => !!document.getElementById('free-chapter') || location.pathname === '/';
  document.querySelectorAll('a[data-home]').forEach(a => {
    a.addEventListener('click', e => {
      if (!isHome()) return; // other pages: normal link to index.html
      e.preventDefault(); e.stopImmediatePropagation();
      const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
      if (location.hash) history.replaceState(null, '', location.pathname + location.search);
      a.blur();
    }, true);
  });
})();
} catch (e) { setTimeout(function () { throw e; }); }
/* ==== luna-v31.js ==== */
try {
(function(){
  if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
  document.documentElement.classList.add('v31');
  var io = new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('v31-in'); io.unobserve(e.target); } }); }, {threshold:.15, rootMargin:'0px 0px -8% 0px'});
  var watch = function(){
    document.querySelectorAll('.section-head, .ksv').forEach(function(el){ io.observe(el); });
    var v = document.querySelector('[data-ksv]'), s = document.querySelector('.ksv');
    if (v && s){ v.addEventListener('playing', function(){ s.classList.add('v31-play'); }); v.addEventListener('pause', function(){ s.classList.remove('v31-play'); }); }
    /* Safety: never leave anything hidden */
    setTimeout(function(){ document.querySelectorAll('.section-head, .ksv').forEach(function(el){ var r=el.getBoundingClientRect(); if(r.top<innerHeight && r.bottom>0) el.classList.add('v31-in'); }); }, 2500);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
})();
} catch (e) { setTimeout(function () { throw e; }); }
/* ==== luna-v32.js ==== */
try {
(function(){
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ready = function(fn){ if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); };
  ready(function(){
    /* Film grain: provided once by luna-perf.css (body::after); the duplicate v32 layer was removed */

    /* Torchlight (desktop pointers only) */
    if (!reduce && matchMedia('(pointer:fine)').matches) {
      var t = document.createElement('div'); t.className = 'v32-torch'; t.setAttribute('aria-hidden','true'); document.body.appendChild(t);
      var x = innerWidth/2, y = innerHeight/2, tx = x, ty = y, raf = 0;
      var loop = function(){ x += (tx-x)*.12; y += (ty-y)*.12; t.style.transform = 'translate3d('+x+'px,'+y+'px,0)'; raf = (Math.abs(tx-x)+Math.abs(ty-y) > .5) ? requestAnimationFrame(loop) : 0; };
      addEventListener('pointermove', function(e){ tx = e.clientX; ty = e.clientY; t.classList.add('on'); if(!raf) raf = requestAnimationFrame(loop); }, {passive:true});
      document.addEventListener('pointerleave', function(){ t.classList.remove('on'); });
    }

    /* Transmission labels: eyebrows decode in when they scroll into view */
    if (!reduce && 'IntersectionObserver' in window) {
      var GL = '▚▞▖▗▘▝01#/<>∆≡';
      var els = [].slice.call(document.querySelectorAll('.section-head .eyebrow')).filter(function(el){ return el.children.length === 0 && el.textContent.trim().length > 2 && el.textContent.trim().length < 70; });
      var run = function(el){
        var final = el.textContent, n = final.length, start = performance.now(), dur = Math.min(1100, 380 + n*22);
        el.classList.add('v32-tx'); el.setAttribute('aria-label', final.trim());
        var step = function(now){
          var p = Math.min(1, (now-start)/dur), shown = Math.floor(p*n), out = '';
          for (var i=0;i<n;i++){ var c = final[i]; if (i < shown || c === ' ') out += c.replace(/&/g,'&amp;').replace(/</g,'&lt;'); else out += '<span class="g">'+GL[(Math.random()*GL.length)|0].replace('<','&lt;')+'</span>'; }
          el.innerHTML = out;
          if (p < 1) requestAnimationFrame(step); else { el.textContent = final; el.removeAttribute('aria-label'); }
        };
        requestAnimationFrame(step);
      };
      var io = new IntersectionObserver(function(es){ es.forEach(function(e){ if (e.isIntersecting){ io.unobserve(e.target); run(e.target); } }); }, {threshold:.6});
      els.forEach(function(el){ io.observe(el); });
    }

    /* Kickstarter ambilight: sample the video's colors */
    var v = document.querySelector('[data-ksv]'), sec = document.querySelector('.ksv');
    if (v && sec) {
      var cv = document.createElement('canvas'); cv.width = 8; cv.height = 5; var cx = cv.getContext('2d', {willReadFrequently:true}), ok = true, timer = 0;
      var sample = function(){
        if (!ok || v.paused || v.readyState < 2) return;
        try {
          cx.drawImage(v, 0, 0, 8, 5); var d = cx.getImageData(0,0,8,5).data, r=0,gg=0,b=0,k=0;
          for (var i=0;i<d.length;i+=4){ r+=d[i]; gg+=d[i+1]; b+=d[i+2]; k++; }
          r/=k; gg/=k; b/=k; var m = Math.max(r,gg,b,1), s = Math.min(255/m, 2.2);
          sec.style.setProperty('--amb', Math.round(Math.max(60,r*s))+' '+Math.round(gg*s*.9)+' '+Math.round(b*s*.9));
        } catch(e){ ok = false; }
      };
      v.addEventListener('playing', function(){ if(!timer) timer = setInterval(sample, 2000); });
      v.addEventListener('pause', function(){ clearInterval(timer); timer = 0; });
    }
  });
})();
} catch (e) { setTimeout(function () { throw e; }); }
